type PlainObject = { [key: string]: any };

export function deepMerge<T extends PlainObject, U extends PlainObject>(target: T, source: U): T & U {
  if (typeof target !== "object" || target === null) return source as T & U;

  const result = { ...target } as T & U;

  for (const key of Object.keys(source) as (keyof U)[]) {
    const srcVal = source[key];
    const tgtVal = result[key];

    if (Array.isArray(srcVal) && Array.isArray(tgtVal)) {
      result[key] = [...tgtVal, ...srcVal] as any;
    } else if (typeof srcVal === "object" && srcVal !== null && typeof tgtVal === "object" && tgtVal !== null && !Array.isArray(tgtVal)) {
      result[key] = deepMerge(tgtVal as PlainObject, srcVal as PlainObject) as any;
    } else {
      result[key] = srcVal as any;
    }
  }

  return result;
}

export default {
  deepMerge,
};
